import React from 'react';
import './styles/global.css';
import { Provider, useSelector } from 'react-redux';
import store from './redux/Store';
import Path from './routes/Path';
import './styles/global.css';
import './App.css';


function App() {
  const { theme } = useSelector((state) => state.theme);

  return (
    <Provider store={store}>
      <div className={`App theme-${theme}`}>
        <Path />
      </div>
    </Provider>
  );
}

export default App;
